<ng-container *ngIf="error">
  <div class="error-container">
    <b><span class="text-red">[ERROR]</span></b> <br>
    <span [innerHTML]="error"></span>
  </div>
</ng-container>

<div class="ui-g" *ngIf="!error">
  <div class="ui-g-12 toolbar-container" *ngIf="element.topToolbarItems && element.topToolbarItems.length > 0">
    <app-generic-toolbar [params]="getToolbarExtraParams()" [items]="element.topToolbarItems" [additionalItems]="element.additionalToolbarItems" [entity]="selectedEntity"></app-generic-toolbar>
  </div>

  <div class="ui-g-12">
    <div class="ui-g-6">
      <div class="ui-g-4">
        {{ 'COST_CENTER.INVOICE' | translate }}:
      </div>

      <div class="ui-g-8" *ngIf="costCenterDmsFile">
        <p-inputNumber
          locale="de-DE"
          mode="decimal"
          [minFractionDigits]="2"
          [(ngModel)]="costCenterDmsFile.amount"
          (onInput)="onTotalAmountChange($event)"
        ></p-inputNumber>
      </div>
    </div>
  </div>

  <div class="ui-g-6">
    <div class="ui-g-4">
      {{ 'COST_CENTER.SPLIT' | translate }}:
    </div>

    <div class="ui-g-8" *ngIf="costCenterDmsFile">
      <p-inputNumber
        locale="de-DE"
        mode="decimal"
        [minFractionDigits]="2"
        [(ngModel)]="costCenterDmsFile.splitAmount"
        (onInput)="onSplitChange($event)"
      ></p-inputNumber>
    </div>
  </div>

  <div class="ui-g-6">
    <div class="ui-g-4">
      {{ 'COST_CENTER.FIXED' | translate }}:
    </div>

    <div class="ui-g-8" *ngIf="costCenterDmsFile">
      <p-inputNumber
        locale="de-DE"
        mode="decimal"
        [disabled]="true"
        [minFractionDigits]="2"
        [(ngModel)]="costCenterDmsFile.fixedAmount"
      ></p-inputNumber>
    </div>
  </div>

  <div class="ui-g-12">
    <shared-dynamic-table
      [columns]="columns"
      [parentComponent]="this"
      [cells]="cells"
      [lazy]="false"
      [rowsCount]="9999"
      [height]="550"
      [entities]="entities"
      [isLoadingData]="isLoading"
      [selectFirstEntityWhenNothingIsSelected]="moduleElement.selectFirst"
      [showFilters]="false"
      [paginator]="false"
      (onCellEdit)="onCellEdit($event)"
      (onCellBlur)="onCellBlur($event)"
      (onCellFocus)="onCellFocus($event)"
      (onCellTabOrEnter)="onCellTabOrEnter($event)"
      (onRowSelected)="onRowSelected($event)"
    ></shared-dynamic-table>
  </div>
</div>
